import "../../App.scss";
import React, { useState, useEffect } from "react";
import Navbar from "./header/Navbar";
import Dashboard from "./Dashboard/Dashboard";
import DashboardRef from "./DashboardRef/Dashboard";
import DashboardNodesMiners from "./DashboardNodesMiners/Dashboard";

import AllAgents from "./AllAgents/AllAgents";
import AllAgentsNodesAndMiners from "./AllAgentsNodesAndMiners/AllAgents";
import AllTransaction from "./AllTransaction/AllTransaction";
import AllTransactionRef from "./AllTransactionRef/AllTransaction";

import AllTransactionNodesMiners from "./TransactionNodesMiners/AllTransaction";

import SalesRound from "./SalesRound/SalesRound";
import SalesRoundRef from "./SalesRoundRef/SalesRound";

import Claim from "./AllClaim/Claim";
import { useHistory } from "react-router-dom";
import axios from "axios";
import { Api_Url } from "../../utils/ApiUrl";
import LeadersAdmin from "./LeaderAdmin/LeadersAdmin";
import Accordion from "react-bootstrap/Accordion";
import InstitutionalStat from "./Institutions/InstitutionalStat";
import AllInstitution from "./AllInstitution/AllInstitution";
import InstituteTransaction from "./InstituteTransaction/InstituteTransaction";
import Tokensettings from "./Tokensettings/Tokensettings";
import TestnetRound from "./TestnetRound/TestnetRound";
import LowCreditError from "./LowCreditError/LowCreditError";
import Stats from "./Stats/Stats";
import InsuranceDetail from "./InsuranceDetail/InsuranceDetail";
import Topccountry from "./Dashboard/Topccountry";
import Topamount from "./Dashboard/Topamount";
import { Offcanvas } from "react-bootstrap";
import Allreferrers from "../Allreferrers/Allreferrers";
import TokenSettingsNodesAndMinors from "./TokenSettingsNodesAndMinors/TokenSettingsNodesAndMinors";
import Allprojects from "./Allprojects/Allprojects";
import UserManagementSetting from "./UserManagementSetting/UserManagementSetting";
import ActivityLog from "./ActivityLog/ActivityLog";
import Creditdashboard from "./Creditdashboard/Creditdashboard";
import Refundprojects from "./Refundprojects/Refundprojects";
import Creditprojects from "./Creditprojects/Creditprojects";
import Whitelistwallets from "./Whitelistwallets/Whitelistwallets";
import Clientsdashboard from "./Clientsdashboard/Clientsdashboard";

function Landing() {
  const indexvv = localStorage.getItem("indexvalue");
  const [indexwait, setindexwait] = useState(0);
  const [routes, setRoutes] = useState(false);
  const [user, setUser] = useState(null);
  let adminType = JSON.parse(localStorage.getItem("user"));
  const val = localStorage.getItem("accessToken");
  const [usdPrice, setUsdPrice] = useState("");
  const [tomiPrice, setTomiPrice] = useState("");
  const [btcPrice, setBtcPrice] = useState("");
  const [pepePrice, setPepePrice] = useState("");
  const [linkPrice, setLinkPrice] = useState("");
  const [uniPrice, setUniPrice] = useState("");
  const [dopPrice, setDopPrice] = useState("");
  const [gemsPrice, setGemsPrice] = useState("");
  console.log('dopPricedopPricedopPrice', linkPrice)
  // useEffect(() => {
  //   if (!tomiPrice) {
  //     getTomiPrice();
  //   }
  //   if (!usdPrice) {
  //     axios
  //       .get("https://min-api.cryptocompare.com/data/price?fsym=ETH&tsyms=USD")
  //       .then((res) => {
  //         setUsdPrice(res?.data?.USD);
  //         // setEthUsd(res.data);
  //       });
  //   }
  //   if (!btcPrice) {
  //     axios
  //       .get("https://min-api.cryptocompare.com/data/price?fsym=BTC&tsyms=USD")
  //       .then((res) => {
  //         setBtcPrice(res?.data?.USD);
  //         // setEthUsd(res.data);
  //       });
  //   }

  //   if (!pepePrice) {
  //     axios
  //       .get("https://min-api.cryptocompare.com/data/price?fsym=PEPE&tsyms=USD")
  //       .then((res) => {
  //         setPepePrice(res?.data?.USD);
  //         // setEthUsd(res.data);
  //       });
  //   }
  //   if (!linkPrice) {
  //     axios
  //       .get("https://min-api.cryptocompare.com/data/price?fsym=LINK&tsyms=USD")
  //       .then((res) => {
  //         setLinkPrice(res?.data?.USD);
  //         // setEthUsd(res.data);
  //       });
  //   }
  //   if (!uniPrice) {
  //     axios
  //       .get("https://min-api.cryptocompare.com/data/price?fsym=UNI&tsyms=USD")
  //       .then((res) => {
  //         setUniPrice(res?.data?.USD);
  //         // setEthUsd(res.data);
  //       });
  //   }
  //   if (!gemsPrice) {
  //     axios
  //       .get("https://min-api.cryptocompare.com/data/price?fsym=GEMS&tsyms=USD")
  //       .then((res) => {
  //         setGemsPrice(res?.data?.USD);
  //         // setEthUsd(res.data);
  //       });
  //   }
  //   if (!dopPrice) {
  //     axios
  //       .get(
  //         `https://mainnet-api-prod.dop.org/transactions/get-price?coinId=data-ownership-protocol`
  //       )
  //       .then((res) => {
  //         const data = res?.data?.data?.market_data?.current_price?.usd;

  //         setDopPrice(data);
  //         // setEthUsd(res.data);
  //       });
  //   }
  // }, []);
  useEffect(() => {
    const fetchAllPrices = async () => {
      try {
        const accessToken = localStorage.getItem("accessToken");
        const res = await axios.get(
          `${Api_Url}/users/prices/all`,
          {
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
          }
        );

        const priceData = res?.data?.data;

        if (Array.isArray(priceData)) {
          priceData.forEach((token) => {
            const symbol = token.symbol?.toUpperCase();
            switch (symbol) {
              case "TOMI":
                if (!tomiPrice) setTomiPrice(token.price);
                break;
              case "ETH":
                if (!usdPrice) setUsdPrice(token.price);
                break;
              case "BTC":
                if (!btcPrice) setBtcPrice(token.price);
                break;
              case "PEPE":
                if (!pepePrice) setPepePrice(token.price);
                break;
              case "LINK":
                if (!linkPrice) setLinkPrice(token.price);
                break;
              case "UNI":
                if (!uniPrice) setUniPrice(token.price);
                break;
              case "GEMS":
                if (!gemsPrice) setGemsPrice(token.price);
                break;
              case "DOP":
                if (!dopPrice) setDopPrice(token.price);
                break;
              default:
                break;
            }
          });
        }
      } catch (error) {
        console.error("Error fetching token prices:", error);
      }
    };

    fetchAllPrices();
  }, []);
  const getTomiPrice = async () => {
    try {
      var config = {
        method: "get",
        url: `${Api_Url}/users/tomi-price`,
      };

      axios(config)
        .then(function (res) {
          setTomiPrice(res?.data?.data);
        })
        .catch(function (error) {
          // console.log(error);
        });
    } catch (error) {
      console.error("Error fetching data:", error);
      // throw error;
    }
  };

  useEffect(() => {
    const checkTokenExpiry = () => {
      if (!val) {
        // Token is not present, user is not logged in
        return;
      }

      // Split the JWT into its parts (header, payload, and signature)
      const parts = val?.split(".");
      if (parts.length !== 3) {
        // Invalid JWT format
        return;
      }

      // Decode the payload
      const payload = JSON.parse(atob(parts[1]));

      // Get the expiration time from the payload
      const expirationTime = payload.exp * 1000; // Convert to milliseconds
      const currentTime = Date.now();

      if (expirationTime < currentTime) {
        // Token has expired
        Logout(); // Call the logout function
      }
    };

    // Check token expiry every minute (you can adjust the interval as needed)
    const intervalId = setInterval(checkTokenExpiry, 60000);
    // Clean up the interval when the component unmounts
    return () => {
      clearInterval(intervalId);
    };
  }, []);

  const history = useHistory();
  useEffect(() => {
    if (val) {
    } else {
      history.push("/login");
    }
    if (indexvv == "0") {
      setindexwait(0);
    } else if (indexvv == "1") {
      setindexwait(1);
    } else if (indexvv == "2") {
      setindexwait(2);
    } else if (indexvv == "3") {
      setindexwait(3);
    } else if (indexvv == "4") {
      setindexwait(4);
    } else if (indexvv == "5") {
      setindexwait(5);
    } else if (indexvv == "6") {
      setindexwait(6);
    } else if (indexvv == "7") {
      setindexwait(7);
    } else if (indexvv == "8") {
      setindexwait(8);
    } else if (indexvv == "9") {
      setindexwait(9);
    } else if (indexvv == "10") {
      setindexwait(10);
    } else if (indexvv == "11") {
      setindexwait(11);
    } else if (indexvv == "12") {
      setindexwait(12);
    } else if (indexvv == "19") {
      setindexwait(19);
    }
    // else if (indexvv == "16") {
    //   setindexwait(16);
    // }
  }, []);
  const hitfunctionss = (asd) => {
    setindexwait(asd);
    localStorage.setItem("indexvalue", asd);
  };
  useEffect(() => {
    window.scrollTo(0, 0);
    let res = localStorage.getItem("userId");
    res = JSON.parse(res);
    GetMyData();
    // setUser(res);
  }, []);

  const GetMyData = async () => {
    const tok = localStorage?.getItem("accessToken");
    // if (account) {
    var config = {
      method: "get",
      url: `${Api_Url}/users/my/stats?privateSale=INCENTIV`,
      // remove the private sale url from here
      headers: {
        authorization: `Bearer ` + tok,
      },
    };
    axios(config)
      .then(function (response) {
        setUser(response?.data?.data);
      })
      .catch(function (error) {
        if (error?.response?.status == 401) {
          // history.push("/login");
        }
        // console.log(error);
      });
    // }
  };
  // console.log("user?.role", user?.role);
  const [sidebar, setSidebar] = useState(false);
  const handleClosesidebar = () => setSidebar(false);

  const Logout = async () => {
    const val = localStorage.getItem("accessToken");
    var config = {
      method: "delete",
      url: `${Api_Url}/auth/users/logout`,
      headers: {
        Authorization: "Bearer " + val,
      },
    };
    axios(config)
      .then(function (response) {
        if (response?.data?.statusCode == 200) {
          localStorage?.removeItem("accessToken");
          localStorage?.removeItem("refreshToken");
          localStorage?.removeItem("userName");
          history.push("/login");
        }
      })
      .catch(function (error) {
        if (error?.response?.status == 401) {
          localStorage.removeItem("accessToken");
          history.push("/login");
        }
      });
  };
console.log('token prices',  usdPrice);

  return (
    <>
      <div style={{ position: "relative", overflow: "hidden" }}>
        <Navbar
          sidebar={sidebar}
          setSidebar={setSidebar}
          user={user}
          GetMyData={GetMyData}
          setindexwait={setindexwait}
          indexwait={indexwait}
        />

        {/* <img src="/leftshade.png" alt="leftshade" className="leftshade" />
        <img src="/midshade.png" alt="leftshade" className="midshade" />
        <img
          src="/leftshadembl.png"
          alt="leftshade"
          className="leftshadembl d-none"
        />
        <img
          src="/rightshadembl.png"
          alt="leftshade"
          className="midshadembl d-none"
        /> */}

        {indexwait == 0 ? (
          <>
            <Dashboard
              setUser={setUser}
              user={user}
              tomiPrice={tomiPrice}
              usdPrice={usdPrice}
              btcPrice={btcPrice}
              pepePrice={pepePrice}
              linkPrice={linkPrice}
              uniPrice={uniPrice}
              dopPrice={dopPrice}
              gemsPrice={gemsPrice}
              hitfunctionss={hitfunctionss}
            />
          </>
        ) : indexwait == 1 ? (
          <>
            <AllAgents
              GetMyData={GetMyData}
              setindexwait={setindexwait}
              user={user}
              setRoutes={setRoutes}
              routes={routes}
              tomiPrice={tomiPrice}
              usdPrice={usdPrice}
              btcPrice={btcPrice}
              pepePrice={pepePrice}
              linkPrice={linkPrice}
              uniPrice={uniPrice}
              dopPrice={dopPrice}
              gemsPrice={gemsPrice}
            />
          </>
        ) : indexwait == 2 ? (
          <AllTransaction
            setindexwait={setindexwait}
            user={user}
            tomiPrice={tomiPrice}
            usdPrice={usdPrice}
            btcPrice={btcPrice}
            pepePrice={pepePrice}
            linkPrice={linkPrice}
            uniPrice={uniPrice}
            dopPrice={dopPrice}
            gemsPrice={gemsPrice}
          />
        ) : indexwait == 3 ? (
          <>
            {user?.role === "admin" && (
              <SalesRound
                setindexwait={setindexwait}
                tomiPrice={tomiPrice}
                usdPrice={usdPrice}
                btcPrice={btcPrice}
                pepePrice={pepePrice}
                linkPrice={linkPrice}
                uniPrice={uniPrice}
                dopPrice={dopPrice}
                gemsPrice={gemsPrice}
              />
            )}
          </>
        ) : indexwait == 4 ? (
          <>
            {
              user?.role === "admin" ? (
                <Claim
                  setindexwait={setindexwait}
                  tomiPrice={tomiPrice}
                  usdPrice={usdPrice}
                  btcPrice={btcPrice}
                  pepePrice={pepePrice}
                  linkPrice={linkPrice}
                  uniPrice={uniPrice}
                  dopPrice={dopPrice}
                  gemsPrice={gemsPrice}
                />
              ) : null
              // <LeadersAdmin
              //   setindexwait={setindexwait}
              //   tomiPrice={tomiPrice}
              //   usdPrice={usdPrice}
              //   btcPrice={btcPrice}
              //   user={user}
              // />
            }
          </>
        ) : indexwait == 5 ? (
          <>
            <InstitutionalStat
              user={user}
              tomiPrice={tomiPrice}
              usdPrice={usdPrice}
              btcPrice={btcPrice}
              pepePrice={pepePrice}
              linkPrice={linkPrice}
              uniPrice={uniPrice}
              dopPrice={dopPrice}
              gemsPrice={gemsPrice}
            />
          </>
        ) : indexwait == 6 ? (
          <>
            <AllInstitution
              user={user}
              routes={routes}
              setRoutes={setRoutes}
              setindexwait={setindexwait}
              tomiPrice={tomiPrice}
              usdPrice={usdPrice}
              btcPrice={btcPrice}
              pepePrice={pepePrice}
              linkPrice={linkPrice}
              uniPrice={uniPrice}
              dopPrice={dopPrice}
              gemsPrice={gemsPrice}
            />
          </>
        ) : indexwait == 7 ? (
          <>
            <InstituteTransaction
              setindexwait={setindexwait}
              user={user}
              usdPrice={usdPrice}
              tomiPrice={tomiPrice}
              btcPrice={btcPrice}
              pepePrice={pepePrice}
              linkPrice={linkPrice}
              uniPrice={uniPrice}
              dopPrice={dopPrice}
              gemsPrice={gemsPrice}
            />
          </>
        ) : indexwait == 8 ? (
          <>
            <Tokensettings
              user={user}
              routes={routes}
              setRoutes={setRoutes}
              setindexwait={setindexwait}
              tomiPrice={tomiPrice}
              usdPrice={usdPrice}
              btcPrice={btcPrice}
              pepePrice={pepePrice}
              linkPrice={linkPrice}
              uniPrice={uniPrice}
              dopPrice={dopPrice}
              gemsPrice={gemsPrice}
            />
          </>
        ) : indexwait == 10 ? (
          <>
            <LowCreditError setindexwait={setindexwait} />
          </>
        ) : indexwait == 11 ? (
          <>
            <Stats user={user} usdPrice={usdPrice} />
          </>
        ) : indexwait == 12 ? (
          <>
            <InsuranceDetail
              setindexwait={setindexwait}
              user={user}
              tomiPrice={tomiPrice}
              usdPrice={usdPrice}
              btcPrice={btcPrice}
              pepePrice={pepePrice}
              linkPrice={linkPrice}
              uniPrice={uniPrice}
              dopPrice={dopPrice}
              gemsPrice={gemsPrice}
            />
          </>
        ) : indexwait == 13 ? (
          <>
            <Topccountry />
          </>
        ) : indexwait == 14 ? (
          <>
            <Topamount />
          </>
        ) : indexwait == 19 ? (
          <>
            <Allreferrers
              setRoutes={setRoutes}
              routes={routes}
              GetMyData={GetMyData}
              setindexwait={setindexwait}
              user={user}
              tomiPrice={tomiPrice}
              usdPrice={usdPrice}
              btcPrice={btcPrice}
              pepePrice={pepePrice}
              linkPrice={linkPrice}
              uniPrice={uniPrice}
              dopPrice={dopPrice}
              gemsPrice={gemsPrice}
            />
          </>
        ) : indexwait == 20 ? (
          <>
            <DashboardRef
              setRoutes={setRoutes}
              routes={routes}
              setUser={setUser}
              user={user}
              tomiPrice={tomiPrice}
              usdPrice={usdPrice}
              btcPrice={btcPrice}
              pepePrice={pepePrice}
              linkPrice={linkPrice}
              uniPrice={uniPrice}
              dopPrice={dopPrice}
              gemsPrice={gemsPrice}
              hitfunctionss={hitfunctionss}
            />
          </>
        ) : indexwait == 21 ? (
          <>
            <AllTransactionRef
              setRoutes={setRoutes}
              routes={routes}
              setUser={setUser}
              user={user}
              tomiPrice={tomiPrice}
              usdPrice={usdPrice}
              btcPrice={btcPrice}
              pepePrice={pepePrice}
              linkPrice={linkPrice}
              uniPrice={uniPrice}
              dopPrice={dopPrice}
              gemsPrice={gemsPrice}
            />
          </>
        ) : indexwait == 22 ? (
          <>
            <SalesRoundRef
              setRoutes={setRoutes}
              routes={routes}
              setUser={setUser}
              user={user}
              tomiPrice={tomiPrice}
              usdPrice={usdPrice}
              btcPrice={btcPrice}
              pepePrice={pepePrice}
              linkPrice={linkPrice}
              uniPrice={uniPrice}
              dopPrice={dopPrice}
              gemsPrice={gemsPrice}
            />
          </>
        ) : indexwait == 24 ? (
          <>
            <DashboardNodesMiners
              setRoutes={setRoutes}
              routes={routes}
              setUser={setUser}
              user={user}
              tomiPrice={tomiPrice}
              usdPrice={usdPrice}
              btcPrice={btcPrice}
              pepePrice={pepePrice}
              linkPrice={linkPrice}
              uniPrice={uniPrice}
              dopPrice={dopPrice}
              gemsPrice={gemsPrice}
              hitfunctionss={hitfunctionss}
            />
          </>
        ) : indexwait == 25 ? (
          <>
            <AllTransactionNodesMiners
              setRoutes={setRoutes}
              routes={routes}
              setUser={setUser}
              user={user}
              tomiPrice={tomiPrice}
              usdPrice={usdPrice}
              btcPrice={btcPrice}
              pepePrice={pepePrice}
              linkPrice={linkPrice}
              uniPrice={uniPrice}
              dopPrice={dopPrice}
              gemsPrice={gemsPrice}
            />
          </>
        ) : indexwait == 26 ? (
          <>
            <TokenSettingsNodesAndMinors
              user={user}
              routes={routes}
              setRoutes={setRoutes}
              setindexwait={setindexwait}
              tomiPrice={tomiPrice}
              usdPrice={usdPrice}
              btcPrice={btcPrice}
              pepePrice={pepePrice}
              linkPrice={linkPrice}
              uniPrice={uniPrice}
              dopPrice={dopPrice}
              gemsPrice={gemsPrice}
            />
          </>
        ) : indexwait == 27 ? (
          <>
            <AllAgentsNodesAndMiners
              GetMyData={GetMyData}
              setindexwait={setindexwait}
              user={user}
              setRoutes={setRoutes}
              routes={routes}
              tomiPrice={tomiPrice}
              usdPrice={usdPrice}
              btcPrice={btcPrice}
              pepePrice={pepePrice}
              linkPrice={linkPrice}
              uniPrice={uniPrice}
              dopPrice={dopPrice}
              gemsPrice={gemsPrice}
            />
          </>
        ) : indexwait == 28 ? (
          <>
            <UserManagementSetting
              user={user}
              routes={routes}
              setRoutes={setRoutes}
              setindexwait={setindexwait}
              tomiPrice={tomiPrice}
              usdPrice={usdPrice}
              btcPrice={btcPrice}
              pepePrice={pepePrice}
              linkPrice={linkPrice}
              uniPrice={uniPrice}
              dopPrice={dopPrice}
              gemsPrice={gemsPrice}
            />
          </>
        ) : indexwait == 29 ? (
          <>
            <ActivityLog
              user={user}
              routes={routes}
              setRoutes={setRoutes}
              setindexwait={setindexwait}
              tomiPrice={tomiPrice}
              usdPrice={usdPrice}
              btcPrice={btcPrice}
              pepePrice={pepePrice}
              linkPrice={linkPrice}
              uniPrice={uniPrice}
              dopPrice={dopPrice}
              gemsPrice={gemsPrice}
            />
          </>
        ) : indexwait == 30 ? (
          <>
            <Creditdashboard
              routes={routes}
              setRoutes={setRoutes}
              setindexwait={setindexwait}
            />
          </>
        ) : indexwait == 31 ? (
          <>
            <Refundprojects
              routes={routes}
              setRoutes={setRoutes}
              setindexwait={setindexwait}
            />
          </>
        ) : indexwait == 32 ? (
          <>
            <Creditprojects
              routes={routes}
              setRoutes={setRoutes}
              setindexwait={setindexwait}
            />
          </>
        ) : indexwait == 33 ? (
          <>
            <Whitelistwallets
              routes={routes}
              setRoutes={setRoutes}
              setindexwait={setindexwait}
            />
          </>
        ) : indexwait == 34 ? (
          <>
            <Clientsdashboard
              routes={routes}
              setRoutes={setRoutes}
              setindexwait={setindexwait}
            />
          </>
        ) : (
          // : indexwait == 28 ? (
          //   <>
          //     <Allprojects
          //       GetMyData={GetMyData}
          //       setindexwait={setindexwait}
          //       user={user}
          //       setRoutes={setRoutes}
          //       routes={routes}
          //       tomiPrice={tomiPrice}
          //       usdPrice={usdPrice}
          //       btcPrice={btcPrice}
          //       pepePrice={pepePrice}
          //       linkPrice={linkPrice}
          //       uniPrice={uniPrice}
          //       dopPrice={dopPrice}
          //       gemsPrice={gemsPrice}
          //     />
          //   </>
          // )
          // : indexwait == 9 ? (
          //   <>
          //     <TestnetRound
          //       user={user}
          //       tomiPrice={tomiPrice}
          //       btcPrice={btcPrice}
          //       usdPrice={usdPrice}
          //     />
          //   </>
          // )
          ""
        )}
      </div>
      {/* {sidebar && ( */}
      <Offcanvas
        show={sidebar}
        onHide={handleClosesidebar}
        className="custom-sidebar"
      >
        <span className="brdrtop"></span>
        <div className="custom-sidebar-top-menu">
          <a
            class="navbar-brand"
            onClick={() => {
              setindexwait(0);
              setSidebar(false);
            }}
          >
           <svg xmlns="http://www.w3.org/2000/svg" width="111" height="30" viewBox="0 0 111 30" fill="none">
  <path d="M39.567 5.78613H42.785L63.5557 24.428H60.3643L51.5613 16.5452L42.785 24.428H39.567L49.9656 15.1071L39.567 5.78613ZM63.5557 5.78613L53.9815 14.388L52.3592 12.95L60.3643 5.78613H63.5557Z" fill="#05BADA"/>
  <path d="M88.718 5.78613H90.8456L110.925 24.428H107.76L90.8456 8.71558V24.428H88.718V5.78613ZM108.824 5.78613H110.925V22.9101L108.824 21.0192V5.78613Z" fill="#05BADA"/>
  <path d="M65.6814 16.1723C65.9474 17.9122 66.7541 19.3681 68.1016 20.5399C69.449 21.7116 71.0181 22.2975 72.8089 22.2975H85.7074V24.428H72.8089C71.1245 24.428 69.5732 24.0197 68.1548 23.203C66.7364 22.3685 65.6105 21.2412 64.7772 19.8208C63.9616 18.4005 63.5538 16.847 63.5538 15.1603C63.5538 14.7875 63.5716 14.4147 63.607 14.0418C75.1315 14.0773 81.665 14.0951 83.2075 14.0951V16.1723H65.6814ZM72.8089 5.78613H85.7074V7.91664H72.8089C71.2132 7.91664 69.7859 8.38712 68.5271 9.32809C67.2683 10.2691 66.4084 11.4764 65.9474 12.95H63.7932C64.2896 10.855 65.3623 9.14168 67.0112 7.81011C68.6601 6.46079 70.5926 5.78613 72.8089 5.78613Z" fill="#05BADA"/>
  <path d="M25.1631 26.0303C22.4905 28.494 18.9215 30 15 30C11.0857 30 7.52155 28.5006 4.85059 26.0449L15 16.9297L25.1631 26.0303ZM12.8594 15L2.92676 23.9023C1.08762 21.4123 0 18.3332 0 15C1.86802e-05 11.6665 1.0873 8.58686 2.92676 6.09668L12.8594 15ZM15 0C18.9207 1.73188e-05 22.4897 1.5049 25.1621 3.96777L16.0703 12.1055L18.248 14.0352L27.0762 6.10254C28.9133 8.5918 30 11.6688 30 15C30 18.3318 28.912 21.4089 27.0742 23.8984L4.85156 3.95312C7.52235 1.4983 11.0865 0 15 0Z" fill="#05BADA"/>
</svg>
          </a>
          <a onClick={() => setSidebar(!sidebar)} class="navbar-brand">
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
  <path d="M19.1049 2.65918L15.6654 2.65918L11 10.9934L14.4394 10.9934L19.1049 2.65918Z" fill="#05BADA"/>
  <path d="M19.1049 19.3452L15.6654 19.3452L11 11.011L13.1677 9.57014L14.4394 11.011L19.1049 19.3452Z" fill="#05BADA"/>
  <path d="M2.90112 2.65918L6.34056 2.65918L11.006 10.9934L7.56656 10.9934L2.90112 2.65918Z" fill="#05BADA"/>
  <path d="M2.90112 19.3452L6.34056 19.3452L11.006 11.011L8.83832 9.57014L7.56656 11.011L2.90112 19.3452Z" fill="#05BADA"/>
</svg>
          </a>
        </div>

        <ul>
          <p className="innerlistpara">Premium Projects</p>
          <li>
            <a
              className={indexwait === 0 ? "active" : ""}
              onClick={() => {
                hitfunctionss(0);
                setSidebar(false);
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="21"
                height="21"
                viewBox="0 0 21 21"
                fill="none"
              >
                <path
                  d="M3.46754 17.4928L1.37785 19.3011L1.37785 11.5772L3.46754 11.5772L3.46754 17.4928Z"
                  fill="#D1DBDF"
                  stroke="#D1DBDF"
                  stroke-width="0.0835874"
                />
                <path
                  d="M3.46754 7.29501L1.37785 9.10339L1.37785 1.37941L3.46754 1.37941L3.46754 7.29501Z"
                  fill="#D1DBDF"
                  stroke="#D1DBDF"
                  stroke-width="0.0835874"
                />
                <rect
                  x="2.38121"
                  y="11.5769"
                  width="7.18851"
                  height="2.08968"
                  fill="#D1DBDF"
                  stroke="#D1DBDF"
                  stroke-width="0.0835874"
                />
                <rect
                  x="2.38121"
                  y="1.37968"
                  width="7.18851"
                  height="2.08968"
                  fill="#D1DBDF"
                  stroke="#D1DBDF"
                  stroke-width="0.0835874"
                />
                <path
                  d="M13.7505 17.4928L11.6608 19.3011L11.6608 11.5772L13.7505 11.5772L13.7505 17.4928Z"
                  fill="#D1DBDF"
                  stroke="#D1DBDF"
                  stroke-width="0.0835874"
                />
                <path
                  d="M13.7505 7.29501L11.6608 9.10339L11.6608 1.37941L13.7505 1.37941L13.7505 7.29501Z"
                  fill="#D1DBDF"
                  stroke="#D1DBDF"
                  stroke-width="0.0835874"
                />
                <rect
                  x="12.6642"
                  y="11.5769"
                  width="7.18851"
                  height="2.08968"
                  fill="#D1DBDF"
                  stroke="#D1DBDF"
                  stroke-width="0.0835874"
                />
                <rect
                  x="17.6793"
                  y="17.261"
                  width="2.17327"
                  height="2.08968"
                  fill="#D1DBDF"
                  stroke="#D1DBDF"
                  stroke-width="0.0835874"
                />
                <rect
                  x="17.6793"
                  y="6.97978"
                  width="2.17327"
                  height="2.08968"
                  fill="#D1DBDF"
                  stroke="#D1DBDF"
                  stroke-width="0.0835874"
                />
                <rect
                  x="7.39818"
                  y="17.261"
                  width="2.17327"
                  height="2.08968"
                  fill="#D1DBDF"
                  stroke="#D1DBDF"
                  stroke-width="0.0835874"
                />
                <rect
                  x="7.39818"
                  y="6.97978"
                  width="2.17327"
                  height="2.08968"
                  fill="#D1DBDF"
                  stroke="#D1DBDF"
                  stroke-width="0.0835874"
                />
                <rect
                  x="12.6642"
                  y="1.37968"
                  width="7.18851"
                  height="2.08968"
                  fill="#D1DBDF"
                  stroke="#D1DBDF"
                  stroke-width="0.0835874"
                />
              </svg>
              Dashboard
            </a>
          </li>
          {user?.role !== "mini_agent" && (
            <li>
              <a
                className={indexwait === 1 ? "active" : ""}
                onClick={() => {
                  hitfunctionss(1);
                  setSidebar(false);
                  setRoutes(false);
                }}
              >
              <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
  <path d="M15.2256 18.728L15.2256 16.3497L9.46249 13.1235L9.46249 15.5019L15.2256 18.728Z" fill="#D1DBDF"/>
  <path d="M0 18.728L7.27727e-07 16.3497L5.7631 13.1235L5.7631 15.5019L0 18.728Z" fill="#D1DBDF"/>
  <path d="M20.8142 18.2222L20.8142 15.8438L15.4747 12.8723L15.4747 15.2507L20.8142 18.2222Z" fill="#D1DBDF"/>
  <circle cx="7.56446" cy="7.06324" r="3.13453" stroke="#D1DBDF" stroke-width="1.88685"/>
  <path d="M13.8334 10.1978C15.5645 10.1978 16.9679 8.79439 16.9679 7.06324C16.9679 5.33209 15.5645 3.92871 13.8334 3.92871" stroke="#D1DBDF" stroke-width="1.88685"/>
</svg>
                All Leaders
              </a>
            </li>
          )}
          <li>
            <a
              className={indexwait === 2 ? "active" : ""}
              onClick={() => {
                hitfunctionss(2);
                setSidebar(false);
              }}
            >
            <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
  <path d="M8.27731 7.88823L9.39371 5.88732L15.7566 5.87837L14.6402 7.87929L8.27731 7.88823Z" fill="#D1DBDF"/>
  <path d="M16.8687 1.04964L20.1704 6.76835L17.6823 6.80535L14.3806 1.08664L16.8687 1.04964Z" fill="#D1DBDF"/>
  <path d="M16.8221 12.4884L20.1238 6.76974L17.6357 6.73274L14.334 12.4515L16.8221 12.4884Z" fill="#D1DBDF"/>
  <path d="M11.8935 13.0893L10.7771 15.0902L4.41421 15.0992L5.53062 13.0983L11.8935 13.0893Z" fill="#D1DBDF"/>
  <path d="M7.47926 1.92676L6.36285 3.92767L0 3.93661L1.1164 1.9357L7.47926 1.92676Z" fill="#D1DBDF"/>
  <path d="M20.1843 17.0518L19.0679 19.0527L12.7051 19.0616L13.8215 17.0607L20.1843 17.0518Z" fill="#D1DBDF"/>
  <path d="M3.30207 19.9274L0.000373103 14.2087L2.48849 14.1717L5.79019 19.8904L3.30207 19.9274Z" fill="#D1DBDF"/>
  <path d="M3.32307 8.48909L0.0213678 14.2078L2.50948 14.2448L5.81119 8.52609L3.32307 8.48909Z" fill="#D1DBDF"/>
</svg>
              All Transactions
            </a>
          </li>
          {user?.role === "admin" && (
            <>
              <li>
                <a
                  className={indexwait === 3 ? "active" : ""}
                  onClick={() => {
                    hitfunctionss(3);
                    setSidebar(false);
                  }}
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
  <path d="M12.7051 3.84521L8.27495 3.84521L8.27495 1.67194L12.7051 1.67194L12.7051 3.84521Z" fill="#D1DBDF"/>
  <path d="M12.7051 18.8071L8.27495 18.8071L8.27495 16.6339L12.7051 16.6339L12.7051 18.8071Z" fill="#D1DBDF"/>
  <path d="M16.8849 12.3711L16.8849 7.94096L19.0582 7.94096L19.0582 12.3711L16.8849 12.3711Z" fill="#D1DBDF"/>
  <path d="M1.92224 12.3711L1.92224 7.94096L4.09551 7.94096L4.09551 12.3711L1.92224 12.3711Z" fill="#D1DBDF"/>
  <path d="M16.5778 7.28418L13.4452 4.1516L14.9819 2.61487L18.1145 5.74745L16.5778 7.28418Z" fill="#D1DBDF"/>
  <path d="M5.99841 17.8643L2.86584 14.7317L4.40257 13.1949L7.53515 16.3275L5.99841 17.8643Z" fill="#D1DBDF"/>
  <path d="M13.5043 16.2681L16.6368 13.1355L18.1736 14.6722L15.041 17.8048L13.5043 16.2681Z" fill="#D1DBDF"/>
  <path d="M2.9248 5.68848L6.05738 2.5559L7.59411 4.09264L4.46154 7.22521L2.9248 5.68848Z" fill="#D1DBDF"/>
  <rect x="8.27527" y="7.94092" width="4.43013" height="4.43013" fill="#D1DBDF"/>
</svg>
                  Sale Rounds
                </a>
              </li>
            </>
          )}
          {
            user?.role === "admin" ? (
              <li>
                <a
                  className={indexwait === 4 ? "active" : ""}
                  onClick={() => {
                    hitfunctionss(4);
                    setSidebar(false);
                  }}
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
  <path d="M17.4694 18.8906L17.4694 7.77351L19.6426 7.77351L19.6426 18.8906L17.4694 18.8906Z" fill="#D1DBDF"/>
  <path d="M1.25415 16.7173L19.6434 16.7173V18.8906L1.25415 18.8906L1.25415 16.7173Z" fill="#D1DBDF"/>
  <path d="M3.42651 7.77344L3.42651 18.8906L1.25324 18.8906L1.25324 7.77344L3.42651 7.77344Z" fill="#D1DBDF"/>
  <path d="M1.96373 2.8418L20.2276 2.8418L19.0155 5.01507H0.751709L1.96373 2.8418Z" fill="#D1DBDF"/>
  <path d="M7.31407 7.77344L19.6432 7.77344L18.4312 9.94671H6.10205L7.31407 7.77344Z" fill="#D1DBDF"/>
  <rect x="13.4576" y="12.7051" width="2.25686" height="2.17327" fill="#D1DBDF"/>
</svg>
                  Leader Claims
                </a>
              </li>
            ) : null
            // <li>
            //   <a
            //     className={indexwait === 3 ? "active" : ""}
            //     onClick={() => {
            //       hitfunctionss(4);
            //       setSidebar(false);
            //     }}
            //   >
            //     <svg
            //       xmlns="http://www.w3.org/2000/svg"
            //       width="24"
            //       height="24"
            //       viewBox="0 0 24 24"
            //       fill="none"
            //     >
            //       <path
            //         d="M20.1611 11.2583H3.83883C3.01932 11.2583 2.35498 11.9226 2.35498 12.7421V20.1614C2.35498 20.9809 3.01932 21.6452 3.83883 21.6452H20.1611C20.9806 21.6452 21.645 20.9809 21.645 20.1614V12.7421C21.645 11.9226 20.9806 11.2583 20.1611 11.2583Z"
            //         stroke="white"
            //         stroke-width="1.5"
            //         stroke-linecap="round"
            //         stroke-linejoin="round"
            //       />
            //       <path
            //         d="M6.80664 4.58075V7.54844M12.0001 2.35498V7.54844M17.1936 4.58075V7.54844"
            //         stroke="white"
            //         stroke-width="1.5"
            //         stroke-linecap="round"
            //         stroke-linejoin="round"
            //       />
            //       <path
            //         d="M11.9999 18.6771C13.2292 18.6771 14.2257 17.6806 14.2257 16.4514C14.2257 15.2221 13.2292 14.2256 11.9999 14.2256C10.7707 14.2256 9.77417 15.2221 9.77417 16.4514C9.77417 17.6806 10.7707 18.6771 11.9999 18.6771Z"
            //         stroke="white"
            //         stroke-width="1.5"
            //         stroke-linecap="round"
            //         stroke-linejoin="round"
            //       />
            //     </svg>
            //     My Claims
            //   </a>
            // </li>
          }
          {/* <li>
            <a
              className={indexwait === 34 ? "active" : ""}
              onClick={() => {
                hitfunctionss(34);
                setSidebar(false);
              }}
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="21" height="22" viewBox="0 0 21 22" fill="none">
                <path d="M19.2285 20.3164L19.2285 17.6247L12.7062 13.9736L12.7062 16.6653L19.2285 20.3164Z" fill="#D1DBDF" />
                <path d="M1.99707 20.3164L1.99707 17.6247L8.5194 13.9736L8.5194 16.6653L1.99707 20.3164Z" fill="#D1DBDF" />
                <path d="M13.0374 7.11538C13.0374 5.74594 11.9278 4.63542 10.5584 4.63528C9.18884 4.63528 8.07827 5.74585 8.07827 7.11538C8.07841 8.48478 9.18893 9.59437 10.5584 9.59437C11.9277 9.59423 13.0372 8.48469 13.0374 7.11538ZM15.1737 7.11538C15.1736 9.66406 13.107 11.7306 10.5584 11.7308C8.00957 11.7308 5.94314 9.66415 5.94299 7.11538C5.94299 4.56648 8.00948 2.5 10.5584 2.5C13.1071 2.50015 15.1737 4.56657 15.1737 7.11538Z" fill="#D1DBDF" />
              </svg>
              Clients Dashboard
            </a>
          </li> */}
          {/* {user?.role === "admin" && (
            <li>
              <Accordion className="institute-accord">
                <Accordion.Item eventKey="0">
                  <Accordion.Header>
                    <a
                      className={
                        indexwait === 5 || indexwait === 6 || indexwait === 7
                          ? "d-flex justify-content-between align-center active"
                          : "d-flex justify-content-between align-center"
                      }
                    >
                      <div>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="21"
                          height="21"
                          viewBox="0 0 21 21"
                          fill="none"
                          style={{ marginRight: "20px" }}
                        >
                          <path
                            d="M6.75179 13.9736L10.2833 20.6796L7.79521 20.7166L4.26367 14.0106L6.75179 13.9736Z"
                            fill="#D1DBDF"
                          />
                          <path
                            d="M14.0686 13.9736L10.537 20.6796L13.0252 20.7166L16.5567 14.0106L14.0686 13.9736Z"
                            fill="#D1DBDF"
                          />
                          <path
                            d="M5.3304 10.4116L10.7468 0.887379L8.25866 0.85038L2.84229 10.3746L5.3304 10.4116Z"
                            fill="#D1DBDF"
                          />
                          <path
                            d="M12.7061 0.850372L18.1225 10.3745L15.6343 10.4115L10.218 0.887371L12.7061 0.850372Z"
                            fill="#D1DBDF"
                          />
                          <path
                            d="M5.00003 9.09985L11.9948 13.4774L10.4905 15.139L2.86376 10.3759L5.00003 9.09985Z"
                            fill="#D1DBDF"
                          />
                          <path
                            d="M15.9603 9.09985L8.9656 13.4774L10.4905 15.139L18.0966 10.3759L15.9603 9.09985Z"
                            fill="#D1DBDF"
                          />
                        </svg>
                        Institutions
                      </div>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="13"
                        height="7"
                        viewBox="0 0 13 7"
                        fill="none"
                        className="arrow"
                      >
                        <path
                          d="M0.601562 0.5L0.601563 3.0462L6.80156 6.5L6.80156 3.9538L0.601562 0.5Z"
                          fill="#D1DBDF"
                        />
                        <path
                          d="M13 0.5L13 3.0462L6.8 6.5L6.8 3.9538L13 0.5Z"
                          fill="#D1DBDF"
                        />
                      </svg>
                    </a>
                  </Accordion.Header>
                  <Accordion.Body>
                    <a
                      onClick={() => {
                        hitfunctionss(5);
                        setSidebar(false);
                      }}
                    >
                      Institutions Stats
                    </a>
                    <a
                      onClick={() => {
                        hitfunctionss(6);
                        setSidebar(false);
                      }}
                    >
                      All Institutions
                    </a>
                    <a
                      onClick={() => {
                        hitfunctionss(7);
                        setSidebar(false);
                      }}
                    >
                      All Transactions
                    </a>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </li>
          )} */}

          {/* {user?.role == "admin" ? (
              <li>
                <a
                  className={indexwait === 11 ? "active" : ""}
                  onClick={() => {
                    hitfunctionss(11);
                    setSidebar(false);
                  }}
                >
                  <img
                    src="\assets\sidebar\stats.svg"
                    alt="img"
                    className="img-fluid"
                  />
                  Stats
                </a>
              </li>
            ) : null} */}
          {/* {user?.role == "admin" ? (
            <li>
              <a
                className={indexwait === 10 ? "active" : ""}
                onClick={() => {
                  hitfunctionss(10);
                  setSidebar(false);
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="21"
                  height="21"
                  viewBox="0 0 21 21"
                  fill="none"
                >
                  <path
                    d="M8.89648 8.75235L8.89648 19.1142L12.0001 17.3833L12.0001 7.17156L8.89648 8.75235Z"
                    fill="#D1DBDF"
                  />
                  <path
                    d="M8.89648 3.46663L8.89648 7.10115L12.0001 5.37029L12.0001 1.88584L8.89648 3.46663Z"
                    fill="#D1DBDF"
                  />
                </svg>
                Low Credit Errors
              </a>
            </li>
          ) : null} */}
          {/* <p className="innerlistpara">Nodes & Miners</p>
          <li>
            <a
              className={indexwait === 24 ? "active" : ""}
              onClick={() => {
                hitfunctionss(24);
                setSidebar(false);
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="21"
                height="21"
                viewBox="0 0 21 21"
                fill="none"
              >
                <path
                  d="M3.46754 17.4928L1.37785 19.3011L1.37785 11.5772L3.46754 11.5772L3.46754 17.4928Z"
                  fill="#D1DBDF"
                  stroke="#D1DBDF"
                  stroke-width="0.0835874"
                />
                <path
                  d="M3.46754 7.29501L1.37785 9.10339L1.37785 1.37941L3.46754 1.37941L3.46754 7.29501Z"
                  fill="#D1DBDF"
                  stroke="#D1DBDF"
                  stroke-width="0.0835874"
                />
                <rect
                  x="2.38121"
                  y="11.5769"
                  width="7.18851"
                  height="2.08968"
                  fill="#D1DBDF"
                  stroke="#D1DBDF"
                  stroke-width="0.0835874"
                />
                <rect
                  x="2.38121"
                  y="1.37968"
                  width="7.18851"
                  height="2.08968"
                  fill="#D1DBDF"
                  stroke="#D1DBDF"
                  stroke-width="0.0835874"
                />
                <path
                  d="M13.7505 17.4928L11.6608 19.3011L11.6608 11.5772L13.7505 11.5772L13.7505 17.4928Z"
                  fill="#D1DBDF"
                  stroke="#D1DBDF"
                  stroke-width="0.0835874"
                />
                <path
                  d="M13.7505 7.29501L11.6608 9.10339L11.6608 1.37941L13.7505 1.37941L13.7505 7.29501Z"
                  fill="#D1DBDF"
                  stroke="#D1DBDF"
                  stroke-width="0.0835874"
                />
                <rect
                  x="12.6642"
                  y="11.5769"
                  width="7.18851"
                  height="2.08968"
                  fill="#D1DBDF"
                  stroke="#D1DBDF"
                  stroke-width="0.0835874"
                />
                <rect
                  x="17.6793"
                  y="17.261"
                  width="2.17327"
                  height="2.08968"
                  fill="#D1DBDF"
                  stroke="#D1DBDF"
                  stroke-width="0.0835874"
                />
                <rect
                  x="17.6793"
                  y="6.97978"
                  width="2.17327"
                  height="2.08968"
                  fill="#D1DBDF"
                  stroke="#D1DBDF"
                  stroke-width="0.0835874"
                />
                <rect
                  x="7.39818"
                  y="17.261"
                  width="2.17327"
                  height="2.08968"
                  fill="#D1DBDF"
                  stroke="#D1DBDF"
                  stroke-width="0.0835874"
                />
                <rect
                  x="7.39818"
                  y="6.97978"
                  width="2.17327"
                  height="2.08968"
                  fill="#D1DBDF"
                  stroke="#D1DBDF"
                  stroke-width="0.0835874"
                />
                <rect
                  x="12.6642"
                  y="1.37968"
                  width="7.18851"
                  height="2.08968"
                  fill="#D1DBDF"
                  stroke="#D1DBDF"
                  stroke-width="0.0835874"
                />
              </svg>
              Dashboard
            </a>
          </li> */}
          {/* <li>
            <a
              className={indexwait === 25 ? "active" : ""}
              onClick={() => {
                hitfunctionss(25);
                setSidebar(false);
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="21"
                height="21"
                viewBox="0 0 21 21"
                fill="none"
              >
                <path
                  d="M8.27731 7.89946L9.39371 5.89855L15.7566 5.8896L14.6402 7.89052L8.27731 7.89946Z"
                  fill="#D1DBDF"
                />
                <path
                  d="M16.8687 1.06111L20.1704 6.77983L17.6823 6.81682L14.3806 1.09811L16.8687 1.06111Z"
                  fill="#D1DBDF"
                />
                <path
                  d="M16.8218 12.4998L20.1235 6.78112L17.6354 6.74412L14.3337 12.4628L16.8218 12.4998Z"
                  fill="#D1DBDF"
                />
                <path
                  d="M11.8936 13.1007L10.7772 15.1016L4.41433 15.1105L5.53074 13.1096L11.8936 13.1007Z"
                  fill="#D1DBDF"
                />
                <path
                  d="M7.47926 1.93826L6.36285 3.93917L0 3.94812L1.1164 1.9472L7.47926 1.93826Z"
                  fill="#D1DBDF"
                />
                <path
                  d="M20.1843 17.0634L19.0679 19.0643L12.7051 19.0733L13.8215 17.0724L20.1843 17.0634Z"
                  fill="#D1DBDF"
                />
                <path
                  d="M3.30219 19.939L0.000495173 14.2203L2.48861 14.1833L5.79031 19.902L3.30219 19.939Z"
                  fill="#D1DBDF"
                />
                <path
                  d="M3.32319 8.50041L0.0214899 14.2191L2.50961 14.2561L5.81131 8.53741L3.32319 8.50041Z"
                  fill="#D1DBDF"
                />
              </svg>
              All Transactions
            </a>
          </li>
          <li>
            <a
              className={indexwait === 27 ? "active" : ""}
              onClick={() => {
                hitfunctionss(27);
                setSidebar(false);
                setRoutes(false);
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="21"
                height="21"
                viewBox="0 0 21 21"
                fill="none"
              >
                <path
                  d="M15.2256 18.7794L15.2256 16.4011L9.46249 13.1749L9.46249 15.5533L15.2256 18.7794Z"
                  fill="#D1DBDF"
                />
                <path
                  d="M0 18.7794L7.27727e-07 16.4011L5.7631 13.1749L5.7631 15.5533L0 18.7794Z"
                  fill="#D1DBDF"
                />
                <path
                  d="M20.814 18.274L20.814 15.8956L15.4745 12.9241L15.4745 15.3025L20.814 18.274Z"
                  fill="#D1DBDF"
                />
                <circle
                  cx="7.56421"
                  cy="7.11484"
                  r="3.13453"
                  stroke="#D1DBDF"
                  stroke-width="1.88685"
                />
                <path
                  d="M13.833 10.2494C15.5642 10.2494 16.9675 8.84602 16.9675 7.11487C16.9675 5.38372 15.5642 3.98035 13.833 3.98035"
                  stroke="#D1DBDF"
                  stroke-width="1.88685"
                />
              </svg>
              All Leaders
            </a>
          </li> */}
          {/* <li>
            <a
              className={indexwait === 26 ? "active" : ""}
              onClick={() => {
                hitfunctionss(26);
                setSidebar(false);
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="21"
                height="21"
                viewBox="0 0 21 21"
                fill="none"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M9.55264 12.9922C6.78963 11.397 5.84295 7.86398 7.43818 5.10097C9.0334 2.33796 12.5664 1.39128 15.3294 2.98651C18.0925 4.58173 19.0391 8.11477 17.4439 10.8778C15.8487 13.6408 12.3156 14.5875 9.55264 12.9922ZM5.89567 4.2104C3.8086 7.82531 5.04716 12.4477 8.66207 14.5347C12.277 16.6218 16.8993 15.3833 18.9864 11.7683C21.0735 8.15344 19.8349 3.53107 16.22 1.444C12.6051 -0.643067 7.98274 0.595493 5.89567 4.2104Z"
                  fill="#D1DBDF"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M4.77591 16.9307C2.31467 14.9006 1.96516 11.2596 3.99525 8.79839L2.62121 7.66505C-0.0348025 10.8851 0.422476 15.6487 3.64257 18.3047C6.86267 20.9607 11.6262 20.5034 14.2822 17.2833L12.9082 16.15C10.8781 18.6112 7.23715 18.9607 4.77591 16.9307Z"
                  fill="#D1DBDF"
                />
                <rect
                  width="4.18191"
                  height="4.18191"
                  transform="matrix(0.707107 0.707107 0.707107 -0.707107 9.48096 8.2294)"
                  fill="#D1DBDF"
                />
              </svg>
              Token Settings
            </a>
          </li> */}
          {/* <p className="innerlistpara">Self Service Projects</p>
          <li>
            <a
              className={indexwait === 20 ? "active" : ""}
              onClick={() => {
                hitfunctionss(20);
                setSidebar(false);
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="21"
                height="21"
                viewBox="0 0 21 21"
                fill="none"
              >
                <path
                  d="M3.46754 17.4928L1.37785 19.3011L1.37785 11.5772L3.46754 11.5772L3.46754 17.4928Z"
                  fill="#D1DBDF"
                  stroke="#D1DBDF"
                  stroke-width="0.0835874"
                />
                <path
                  d="M3.46754 7.29501L1.37785 9.10339L1.37785 1.37941L3.46754 1.37941L3.46754 7.29501Z"
                  fill="#D1DBDF"
                  stroke="#D1DBDF"
                  stroke-width="0.0835874"
                />
                <rect
                  x="2.38121"
                  y="11.5769"
                  width="7.18851"
                  height="2.08968"
                  fill="#D1DBDF"
                  stroke="#D1DBDF"
                  stroke-width="0.0835874"
                />
                <rect
                  x="2.38121"
                  y="1.37968"
                  width="7.18851"
                  height="2.08968"
                  fill="#D1DBDF"
                  stroke="#D1DBDF"
                  stroke-width="0.0835874"
                />
                <path
                  d="M13.7505 17.4928L11.6608 19.3011L11.6608 11.5772L13.7505 11.5772L13.7505 17.4928Z"
                  fill="#D1DBDF"
                  stroke="#D1DBDF"
                  stroke-width="0.0835874"
                />
                <path
                  d="M13.7505 7.29501L11.6608 9.10339L11.6608 1.37941L13.7505 1.37941L13.7505 7.29501Z"
                  fill="#D1DBDF"
                  stroke="#D1DBDF"
                  stroke-width="0.0835874"
                />
                <rect
                  x="12.6642"
                  y="11.5769"
                  width="7.18851"
                  height="2.08968"
                  fill="#D1DBDF"
                  stroke="#D1DBDF"
                  stroke-width="0.0835874"
                />
                <rect
                  x="17.6793"
                  y="17.261"
                  width="2.17327"
                  height="2.08968"
                  fill="#D1DBDF"
                  stroke="#D1DBDF"
                  stroke-width="0.0835874"
                />
                <rect
                  x="17.6793"
                  y="6.97978"
                  width="2.17327"
                  height="2.08968"
                  fill="#D1DBDF"
                  stroke="#D1DBDF"
                  stroke-width="0.0835874"
                />
                <rect
                  x="7.39818"
                  y="17.261"
                  width="2.17327"
                  height="2.08968"
                  fill="#D1DBDF"
                  stroke="#D1DBDF"
                  stroke-width="0.0835874"
                />
                <rect
                  x="7.39818"
                  y="6.97978"
                  width="2.17327"
                  height="2.08968"
                  fill="#D1DBDF"
                  stroke="#D1DBDF"
                  stroke-width="0.0835874"
                />
                <rect
                  x="12.6642"
                  y="1.37968"
                  width="7.18851"
                  height="2.08968"
                  fill="#D1DBDF"
                  stroke="#D1DBDF"
                  stroke-width="0.0835874"
                />
              </svg>
              Dashboard
            </a>
          </li>
          <li>
            <a
              className={indexwait === 19 ? "active" : ""}
              onClick={() => {
                hitfunctionss(19);
                setSidebar(false);
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="21"
                height="21"
                viewBox="0 0 21 21"
                fill="none"
              >
                <path
                  d="M15.2256 18.7794L15.2256 16.4011L9.46249 13.175L9.46249 15.5533L15.2256 18.7794Z"
                  fill="#D1DBDF"
                />
                <path
                  d="M0 18.7794L7.27727e-07 16.4011L5.7631 13.175L5.7631 15.5533L0 18.7794Z"
                  fill="#D1DBDF"
                />
                <path
                  d="M20.814 18.274L20.814 15.8956L15.4745 12.9241L15.4745 15.3025L20.814 18.274Z"
                  fill="#D1DBDF"
                />
                <circle
                  cx="7.56421"
                  cy="7.11484"
                  r="3.13453"
                  stroke="#D1DBDF"
                  stroke-width="1.88685"
                />
                <path
                  d="M13.833 10.2494C15.5642 10.2494 16.9675 8.84602 16.9675 7.11487C16.9675 5.38372 15.5642 3.98035 13.833 3.98035"
                  stroke="#D1DBDF"
                  stroke-width="1.88685"
                />
              </svg>
              All Referrers
            </a>
          </li> */}
          {/* <li>
            <a
              className={indexwait === 28 ? "active" : ""}
              onClick={() => {
                hitfunctionss(28);
                setSidebar(false);
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="21"
                height="16"
                viewBox="0 0 21 16"
                fill="none"
              >
                <path
                  d="M4.36458 10.9319L9.95296 10.9319L8.89239 8.81074L3.18164 8.81074L4.36458 10.9319Z"
                  fill="#D1DBDF"
                />
                <path
                  d="M7.50558 10.8911L10.1963 15.7464L11.5172 13.7768L8.89247 8.85151L7.50558 10.8911Z"
                  fill="#D1DBDF"
                />
                <path
                  d="M4.44619 11.0135L1.84448 15.7465L0.523614 13.7769L2.20268 11.0135L4.44619 11.0135Z"
                  fill="#D1DBDF"
                />
                <path
                  d="M13.0941 10.9319L18.6825 10.9319L17.6219 8.81074L11.9111 8.81074L13.0941 10.9319Z"
                  fill="#D1DBDF"
                />
                <path
                  d="M16.2351 10.8911L18.9258 15.7464L20.2467 13.7768L17.622 8.85151L16.2351 10.8911Z"
                  fill="#D1DBDF"
                />
                <path
                  d="M8.93343 2.12109L14.5218 2.12109L13.4612 -5.19977e-05L7.75049 -5.24521e-05L8.93343 2.12109Z"
                  fill="#D1DBDF"
                />
                <path
                  d="M12.0744 2.08029L14.7652 6.93563L16.0861 4.96602L13.4613 0.0407237L12.0744 2.08029Z"
                  fill="#D1DBDF"
                />
                <path
                  d="M9.01504 2.2027L6.41333 6.93567L5.09246 4.96606L6.77153 2.2027L9.01504 2.2027Z"
                  fill="#D1DBDF"
                />
              </svg>
              All Projects
            </a>
          </li> */}
          {/* <li>
            <a
              className={indexwait === 21 ? "active" : ""}
              onClick={() => {
                hitfunctionss(21);
                setSidebar(false);
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="21"
                height="21"
                viewBox="0 0 21 21"
                fill="none"
              >
                <path
                  d="M8.27731 7.89946L9.39371 5.89855L15.7566 5.8896L14.6402 7.89052L8.27731 7.89946Z"
                  fill="#D1DBDF"
                />
                <path
                  d="M16.8687 1.06111L20.1704 6.77983L17.6823 6.81682L14.3806 1.09811L16.8687 1.06111Z"
                  fill="#D1DBDF"
                />
                <path
                  d="M16.8218 12.4998L20.1235 6.78112L17.6354 6.74412L14.3337 12.4628L16.8218 12.4998Z"
                  fill="#D1DBDF"
                />
                <path
                  d="M11.8936 13.1007L10.7772 15.1016L4.41433 15.1105L5.53074 13.1096L11.8936 13.1007Z"
                  fill="#D1DBDF"
                />
                <path
                  d="M7.47926 1.93826L6.36285 3.93917L0 3.94812L1.1164 1.9472L7.47926 1.93826Z"
                  fill="#D1DBDF"
                />
                <path
                  d="M20.1843 17.0634L19.0679 19.0643L12.7051 19.0733L13.8215 17.0724L20.1843 17.0634Z"
                  fill="#D1DBDF"
                />
                <path
                  d="M3.30219 19.939L0.000495173 14.2203L2.48861 14.1833L5.79031 19.902L3.30219 19.939Z"
                  fill="#D1DBDF"
                />
                <path
                  d="M3.32319 8.50041L0.0214899 14.2191L2.50961 14.2561L5.81131 8.53741L3.32319 8.50041Z"
                  fill="#D1DBDF"
                />
              </svg>
              All Transactions
            </a>
          </li>
          {user?.role === "admin" && (
            <>
              <li>
                <a
                  className={indexwait === 22 ? "active" : ""}
                  onClick={() => {
                    hitfunctionss(22);
                    setSidebar(false);
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="21"
                    height="21"
                    viewBox="0 0 21 21"
                    fill="none"
                  >
                    <path
                      d="M12.7051 3.89658L8.27495 3.89658L8.27495 1.7233L12.7051 1.7233L12.7051 3.89658Z"
                      fill="#D1DBDF"
                    />
                    <path
                      d="M12.7051 18.8587L8.27495 18.8587L8.27495 16.6854L12.7051 16.6854L12.7051 18.8587Z"
                      fill="#D1DBDF"
                    />
                    <path
                      d="M16.8848 12.4225L16.8848 7.99242L19.058 7.99242L19.058 12.4225L16.8848 12.4225Z"
                      fill="#D1DBDF"
                    />
                    <path
                      d="M1.92236 12.4225L1.92236 7.99242L4.09563 7.99242L4.09563 12.4225L1.92236 12.4225Z"
                      fill="#D1DBDF"
                    />
                    <path
                      d="M16.5776 7.33575L13.4451 4.20318L14.9818 2.66644L18.1144 5.79902L16.5776 7.33575Z"
                      fill="#D1DBDF"
                    />
                    <path
                      d="M5.99854 17.9156L2.86596 14.7831L4.4027 13.2463L7.53527 16.3789L5.99854 17.9156Z"
                      fill="#D1DBDF"
                    />
                    <path
                      d="M13.5044 16.3198L16.637 13.1872L18.1737 14.724L15.0411 17.8565L13.5044 16.3198Z"
                      fill="#D1DBDF"
                    />
                    <path
                      d="M2.9248 5.73987L6.05738 2.60729L7.59411 4.14403L4.46154 7.2766L2.9248 5.73987Z"
                      fill="#D1DBDF"
                    />
                    <rect
                      x="8.27539"
                      y="7.9924"
                      width="4.43013"
                      height="4.43013"
                      fill="#D1DBDF"
                    />
                  </svg>
                  Sale Rounds
                </a>
              </li>
            </>
          )} */}
          {/* <p className="innerlistpara">Credit Refund</p>
          <li>
            <a
              className={indexwait === 30 ? "active" : ""}
              onClick={() => {
                hitfunctionss(30);
                setSidebar(false);
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="21"
                height="22"
                viewBox="0 0 21 22"
                fill="none"
              >
                <path
                  d="M3.46754 18.2908L1.37785 20.0992L1.37785 12.3752L3.46754 12.3752L3.46754 18.2908Z"
                  fill="#D1DBDF"
                  stroke="#D1DBDF"
                  stroke-width="0.0835874"
                />
                <path
                  d="M3.46754 8.09316L1.37785 9.90154L1.37785 2.17756L3.46754 2.17756L3.46754 8.09316Z"
                  fill="#D1DBDF"
                  stroke="#D1DBDF"
                  stroke-width="0.0835874"
                />
                <rect
                  x="2.38115"
                  y="12.3752"
                  width="7.18851"
                  height="2.08968"
                  fill="#D1DBDF"
                  stroke="#D1DBDF"
                  stroke-width="0.0835874"
                />
                <rect
                  x="2.38115"
                  y="2.17754"
                  width="7.18851"
                  height="2.08968"
                  fill="#D1DBDF"
                  stroke="#D1DBDF"
                  stroke-width="0.0835874"
                />
                <path
                  d="M13.7505 18.2908L11.6608 20.0992L11.6608 12.3752L13.7505 12.3752L13.7505 18.2908Z"
                  fill="#D1DBDF"
                  stroke="#D1DBDF"
                  stroke-width="0.0835874"
                />
                <path
                  d="M13.7505 8.09316L11.6608 9.90154L11.6608 2.17756L13.7505 2.17756L13.7505 8.09316Z"
                  fill="#D1DBDF"
                  stroke="#D1DBDF"
                  stroke-width="0.0835874"
                />
                <rect
                  x="12.6642"
                  y="12.3752"
                  width="7.18851"
                  height="2.08968"
                  fill="#D1DBDF"
                  stroke="#D1DBDF"
                  stroke-width="0.0835874"
                />
                <rect
                  x="17.6794"
                  y="18.0591"
                  width="2.17327"
                  height="2.08968"
                  fill="#D1DBDF"
                  stroke="#D1DBDF"
                  stroke-width="0.0835874"
                />
                <rect
                  x="17.6794"
                  y="7.77788"
                  width="2.17327"
                  height="2.08968"
                  fill="#D1DBDF"
                  stroke="#D1DBDF"
                  stroke-width="0.0835874"
                />
                <rect
                  x="7.39824"
                  y="18.0591"
                  width="2.17327"
                  height="2.08968"
                  fill="#D1DBDF"
                  stroke="#D1DBDF"
                  stroke-width="0.0835874"
                />
                <rect
                  x="7.39824"
                  y="7.77788"
                  width="2.17327"
                  height="2.08968"
                  fill="#D1DBDF"
                  stroke="#D1DBDF"
                  stroke-width="0.0835874"
                />
                <rect
                  x="12.6642"
                  y="2.17754"
                  width="7.18851"
                  height="2.08968"
                  fill="#D1DBDF"
                  stroke="#D1DBDF"
                  stroke-width="0.0835874"
                />
              </svg>
              Dashboard
            </a>
          </li>
          <li>
            <a
              className={indexwait === 31 ? "active" : ""}
              onClick={() => {
                hitfunctionss(31);
                setSidebar(false);
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="21"
                height="17"
                viewBox="0 0 21 17"
                fill="none"
              >
                <path
                  d="M4.3647 11.6786L9.95308 11.6786L8.89252 9.5575L3.18176 9.5575L4.3647 11.6786Z"
                  fill="#D1DBDF"
                />
                <path
                  d="M7.50558 11.6378L10.1963 16.4932L11.5172 14.5236L8.89247 9.59828L7.50558 11.6378Z"
                  fill="#D1DBDF"
                />
                <path
                  d="M4.44631 11.7603L1.8446 16.4932L0.523736 14.5236L2.20281 11.7603L4.44631 11.7603Z"
                  fill="#D1DBDF"
                />
                <path
                  d="M13.0941 11.6786L18.6825 11.6786L17.6219 9.5575L11.9111 9.5575L13.0941 11.6786Z"
                  fill="#D1DBDF"
                />
                <path
                  d="M16.2351 11.6378L18.9258 16.4932L20.2467 14.5236L17.622 9.59828L16.2351 11.6378Z"
                  fill="#D1DBDF"
                />
                <path
                  d="M8.93343 2.86773L14.5218 2.86774L13.4612 0.746591L7.75049 0.746591L8.93343 2.86773Z"
                  fill="#D1DBDF"
                />
                <path
                  d="M12.0743 2.82693L14.7651 7.68227L16.0859 5.71266L13.4612 0.787367L12.0743 2.82693Z"
                  fill="#D1DBDF"
                />
                <path
                  d="M9.01504 2.94935L6.41333 7.68231L5.09246 5.7127L6.77153 2.94935L9.01504 2.94935Z"
                  fill="#D1DBDF"
                />
              </svg>
              Refund Projects
            </a>
          </li>
          <li>
            <a
              className={indexwait === 32 ? "active" : ""}
              onClick={() => {
                hitfunctionss(32);
                setSidebar(false);
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="21"
                height="17"
                viewBox="0 0 21 17"
                fill="none"
              >
                <path
                  d="M4.3647 11.6786L9.95308 11.6786L8.89252 9.5575L3.18176 9.5575L4.3647 11.6786Z"
                  fill="#D1DBDF"
                />
                <path
                  d="M7.50558 11.6378L10.1963 16.4932L11.5172 14.5236L8.89247 9.59828L7.50558 11.6378Z"
                  fill="#D1DBDF"
                />
                <path
                  d="M4.44631 11.7603L1.8446 16.4932L0.523736 14.5236L2.20281 11.7603L4.44631 11.7603Z"
                  fill="#D1DBDF"
                />
                <path
                  d="M13.0941 11.6786L18.6825 11.6786L17.6219 9.5575L11.9111 9.5575L13.0941 11.6786Z"
                  fill="#D1DBDF"
                />
                <path
                  d="M16.2351 11.6378L18.9258 16.4932L20.2467 14.5236L17.622 9.59828L16.2351 11.6378Z"
                  fill="#D1DBDF"
                />
                <path
                  d="M8.93343 2.86773L14.5218 2.86774L13.4612 0.746591L7.75049 0.746591L8.93343 2.86773Z"
                  fill="#D1DBDF"
                />
                <path
                  d="M12.0743 2.82693L14.7651 7.68227L16.0859 5.71266L13.4612 0.787367L12.0743 2.82693Z"
                  fill="#D1DBDF"
                />
                <path
                  d="M9.01504 2.94935L6.41333 7.68231L5.09246 5.7127L6.77153 2.94935L9.01504 2.94935Z"
                  fill="#D1DBDF"
                />
              </svg>
              Buy with Credit Projects
            </a>
          </li>
          <li>
            <a
              className={indexwait === 33 ? "active" : ""}
              onClick={() => {
                hitfunctionss(33);
                setSidebar(false);
              }}
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="21" height="22" viewBox="0 0 21 22" fill="none">
                <path d="M17.4694 19.422L17.4694 8.30488L19.6426 8.30488L19.6426 19.422L17.4694 19.422Z" fill="#D1DBDF" />
                <path d="M1.25415 17.2487L19.6434 17.2487V19.4219L1.25415 19.4219L1.25415 17.2487Z" fill="#D1DBDF" />
                <path d="M3.42651 8.30469L3.42651 19.4218L1.25324 19.4218L1.25324 8.30469L3.42651 8.30469Z" fill="#D1DBDF" />
                <path d="M1.96373 3.37317L20.2276 3.37317L19.0155 5.54644H0.751709L1.96373 3.37317Z" fill="#D1DBDF" />
                <path d="M7.31407 8.30469L19.6432 8.30469L18.4312 10.478H6.10205L7.31407 8.30469Z" fill="#D1DBDF" />
                <rect x="13.4576" y="13.2365" width="2.25686" height="2.17327" fill="#D1DBDF" />
              </svg>
              Whitelist Wallets
            </a>
          </li> */}
          <p className="innerlistpara">Settings</p>
          {user?.role == "admin" ? (
            <li>
              <a
                className={indexwait === 8 ? "active" : ""}
                onClick={() => {
                  hitfunctionss(8);
                  setSidebar(false);
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="21"
                  height="21"
                  viewBox="0 0 21 21"
                  fill="none"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M9.55264 12.9922C6.78963 11.397 5.84295 7.86398 7.43818 5.10097C9.0334 2.33796 12.5664 1.39128 15.3294 2.98651C18.0925 4.58173 19.0391 8.11477 17.4439 10.8778C15.8487 13.6408 12.3156 14.5875 9.55264 12.9922ZM5.89567 4.2104C3.8086 7.82531 5.04716 12.4477 8.66207 14.5347C12.277 16.6218 16.8993 15.3833 18.9864 11.7683C21.0735 8.15344 19.8349 3.53107 16.22 1.444C12.6051 -0.643067 7.98274 0.595493 5.89567 4.2104Z"
                    fill="#D1DBDF"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M4.77591 16.9307C2.31467 14.9006 1.96516 11.2596 3.99525 8.79839L2.62121 7.66505C-0.0348025 10.8851 0.422476 15.6487 3.64257 18.3047C6.86267 20.9607 11.6262 20.5034 14.2822 17.2833L12.9082 16.15C10.8781 18.6112 7.23715 18.9607 4.77591 16.9307Z"
                    fill="#D1DBDF"
                  />
                  <rect
                    width="4.18191"
                    height="4.18191"
                    transform="matrix(0.707107 0.707107 0.707107 -0.707107 9.48096 8.2294)"
                    fill="#D1DBDF"
                  />
                </svg>
                Token Settings
              </a>
            </li>
          ) : null}
          {adminType?.primeAdmin && <>
            <li>
              <a
                className={indexwait === 28 ? "active" : ""}
                onClick={() => {
                  hitfunctionss(28);
                  setSidebar(false);
                }}
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                  <path d="M15.2256 18.7794L15.2256 16.4011L9.46249 13.1749L9.46249 15.5533L15.2256 18.7794Z" fill="#D1DBDF" />
                  <path d="M0 18.7794L7.27727e-07 16.4011L5.7631 13.1749L5.7631 15.5533L0 18.7794Z" fill="#D1DBDF" />
                  <path d="M20.8142 18.274L20.8142 15.8956L15.4747 12.9242L15.4747 15.3025L20.8142 18.274Z" fill="#D1DBDF" />
                  <circle cx="7.56446" cy="7.11481" r="3.13453" stroke="#D1DBDF" stroke-width="1.88685" />
                  <path d="M13.8333 10.2493C15.5644 10.2493 16.9678 8.84596 16.9678 7.11481C16.9678 5.38366 15.5644 3.98029 13.8333 3.98029" stroke="#D1DBDF" stroke-width="1.88685" />
                </svg>
                User Management
              </a>
            </li>
            <li>
              <a
                className={indexwait === 29 ? "active" : ""}
                onClick={() => {
                  hitfunctionss(29);
                  setSidebar(false);
                }}
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                  <path d="M8.27731 7.89934L9.39371 5.89842L15.7566 5.88948L14.6402 7.89039L8.27731 7.89934Z" fill="#D1DBDF" />
                  <path d="M16.8687 1.06099L20.1704 6.7797L17.6823 6.8167L14.3806 1.09799L16.8687 1.06099Z" fill="#D1DBDF" />
                  <path d="M16.8221 12.4998L20.1238 6.78109L17.6357 6.74409L14.334 12.4628L16.8221 12.4998Z" fill="#D1DBDF" />
                  <path d="M11.8936 13.1007L10.7772 15.1016L4.41433 15.1105L5.53074 13.1096L11.8936 13.1007Z" fill="#D1DBDF" />
                  <path d="M7.47926 1.93823L6.36285 3.93914L0 3.94808L1.1164 1.94717L7.47926 1.93823Z" fill="#D1DBDF" />
                  <path d="M20.1843 17.0634L19.0679 19.0643L12.7051 19.0732L13.8215 17.0723L20.1843 17.0634Z" fill="#D1DBDF" />
                  <path d="M3.30219 19.939L0.000495173 14.2203L2.48861 14.1833L5.79031 19.902L3.30219 19.939Z" fill="#D1DBDF" />
                  <path d="M3.32295 8.50032L0.0212457 14.219L2.50936 14.256L5.81106 8.53732L3.32295 8.50032Z" fill="#D1DBDF" />
                </svg>
                Activity Log
              </a>
            </li>
          </>}
          {/* <li>
              <a
                className={indexwait === 12 ? "active" : ""}
                onClick={() => {
                  hitfunctionss(12);
                  setSidebar(false);
                }}
              >
                <img
                  src="\assets\sidebar\inusrancedetail.svg"
                  alt="img"
                  className="img-fluid"
                />
                Insurance Details
              </a>
            </li> */}
          {/* <li>
              <a
                className={indexwait === 9 ? "active" : ""}
                onClick={() => {
                  hitfunctionss(9);
                  setSidebar(false);
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M17.9998 7.91002C17.9698 7.91002 17.9498 7.91002 17.9198 7.91002H17.8698C15.9798 7.85002 14.5698 6.39001 14.5698 4.59001C14.5698 2.75001 16.0698 1.26001 17.8998 1.26001C19.7298 1.26001 21.2298 2.76001 21.2298 4.59001C21.2198 6.40001 19.8098 7.86001 18.0098 7.92001C18.0098 7.91001 18.0098 7.91002 17.9998 7.91002ZM17.8998 2.75002C16.8898 2.75002 16.0698 3.57002 16.0698 4.58002C16.0698 5.57002 16.8398 6.37002 17.8298 6.41002C17.8398 6.40002 17.9198 6.40002 18.0098 6.41002C18.9798 6.36002 19.7298 5.56002 19.7398 4.58002C19.7398 3.57002 18.9198 2.75002 17.8998 2.75002Z"
                    fill="white"
                  />
                  <path
                    d="M18.01 15.28C17.62 15.28 17.23 15.25 16.84 15.18C16.43 15.11 16.16 14.72 16.23 14.31C16.3 13.9 16.69 13.63 17.1 13.7C18.33 13.91 19.63 13.68 20.5 13.1C20.97 12.79 21.22 12.4 21.22 12.01C21.22 11.62 20.96 11.24 20.5 10.93C19.63 10.35 18.31 10.12 17.07 10.34C16.66 10.42 16.27 10.14 16.2 9.73002C16.13 9.32002 16.4 8.93003 16.81 8.86003C18.44 8.57003 20.13 8.88002 21.33 9.68002C22.21 10.27 22.72 11.11 22.72 12.01C22.72 12.9 22.22 13.75 21.33 14.35C20.42 14.95 19.24 15.28 18.01 15.28Z"
                    fill="white"
                  />
                  <path
                    d="M5.96998 7.91C5.95998 7.91 5.94998 7.91 5.94998 7.91C4.14998 7.85 2.73998 6.39 2.72998 4.59C2.72998 2.75 4.22998 1.25 6.05998 1.25C7.88998 1.25 9.38998 2.75 9.38998 4.58C9.38998 6.39 7.97998 7.85 6.17998 7.91L5.96998 7.16L6.03998 7.91C6.01998 7.91 5.98998 7.91 5.96998 7.91ZM6.06998 6.41C6.12998 6.41 6.17998 6.41 6.23998 6.42C7.12998 6.38 7.90998 5.58 7.90998 4.59C7.90998 3.58 7.08998 2.75999 6.07998 2.75999C5.06998 2.75999 4.24998 3.58 4.24998 4.59C4.24998 5.57 5.00998 6.36 5.97998 6.42C5.98998 6.41 6.02998 6.41 6.06998 6.41Z"
                    fill="white"
                  />
                  <path
                    d="M5.96 15.28C4.73 15.28 3.55 14.95 2.64 14.35C1.76 13.76 1.25 12.91 1.25 12.01C1.25 11.12 1.76 10.27 2.64 9.68002C3.84 8.88002 5.53 8.57003 7.16 8.86003C7.57 8.93003 7.84 9.32002 7.77 9.73002C7.7 10.14 7.31 10.42 6.9 10.34C5.66 10.12 4.35 10.35 3.47 10.93C3 11.24 2.75 11.62 2.75 12.01C2.75 12.4 3.01 12.79 3.47 13.1C4.34 13.68 5.64 13.91 6.87 13.7C7.28 13.63 7.67 13.91 7.74 14.31C7.81 14.72 7.54 15.11 7.13 15.18C6.74 15.25 6.35 15.28 5.96 15.28Z"
                    fill="white"
                  />
                  <path
                    d="M11.9998 15.38C11.9698 15.38 11.9498 15.38 11.9198 15.38H11.8698C9.97982 15.32 8.56982 13.86 8.56982 12.06C8.56982 10.22 10.0698 8.72998 11.8998 8.72998C13.7298 8.72998 15.2298 10.23 15.2298 12.06C15.2198 13.87 13.8098 15.33 12.0098 15.39C12.0098 15.38 12.0098 15.38 11.9998 15.38ZM11.8998 10.22C10.8898 10.22 10.0698 11.04 10.0698 12.05C10.0698 13.04 10.8398 13.84 11.8298 13.88C11.8398 13.87 11.9198 13.87 12.0098 13.88C12.9798 13.83 13.7298 13.03 13.7398 12.05C13.7398 11.05 12.9198 10.22 11.8998 10.22Z"
                    fill="white"
                  />
                  <path
                    d="M11.9998 22.76C10.7998 22.76 9.59978 22.45 8.66978 21.82C7.78978 21.23 7.27979 20.39 7.27979 19.49C7.27979 18.6 7.77978 17.74 8.66978 17.15C10.5398 15.91 13.4698 15.91 15.3298 17.15C16.2098 17.74 16.7198 18.58 16.7198 19.48C16.7198 20.37 16.2198 21.23 15.3298 21.82C14.3998 22.44 13.1998 22.76 11.9998 22.76ZM9.49979 18.41C9.02979 18.72 8.77979 19.11 8.77979 19.5C8.77979 19.89 9.03979 20.27 9.49979 20.58C10.8498 21.49 13.1398 21.49 14.4898 20.58C14.9598 20.27 15.2098 19.88 15.2098 19.49C15.2098 19.1 14.9498 18.72 14.4898 18.41C13.1498 17.5 10.8598 17.51 9.49979 18.41Z"
                    fill="white"
                  />
                </svg>
                Testnet Round
              </a>
            </li> */}
          <div className="btnsmains">
            <Navbar setSidebar={setSidebar} mobileNav={true} />
            <button onClick={() => Logout()} className="logout-btn d-none">
              Logout
            </button>
          </div>
        </ul>
      </Offcanvas>
      {/* )} */}
    </>
  );
}

export default Landing;